import CustomerMasterData from "../view/DataSync/CustomerMasterData/CustomerMasterData";
import BasicInformation from "../view/DataSync/BasicInformation/BasicInformation";
import BasicInformationAdd from "../view/DataSync/BasicInformation/BasicInformationAdd";
import BasicInformationModify from "../view/DataSync/BasicInformation/BasicInformationModify";
import CostCenter from "../view/DataSync/CostCenter/CostCenter";
import CostCenterAdd from "../view/DataSync/CostCenter/CostCenterAdd";
import CostCenterModify from "../view/DataSync/CostCenter/CostCenterModify";
import ScenarioTemplate from "../view/DataSync/ScenarioTemplate/ScenarioTemplate";
import ScenarioTemplateAdd from "../view/DataSync/ScenarioTemplate/ScenarioTemplateAdd";
import ScenarioTemplateModify from "../view/DataSync/ScenarioTemplate/ScenarioTemplateModify";
import DataSyncNav from "../view/DataSync/DataSyncNav";

export default [
  {
    path: "/customer_master_data",
    name: "customer-master-data",
    components: {
      default: DataSyncNav,
      a: CustomerMasterData
    }
  },
  {
    path: "/basic_information",
    name: "basic-information",
    components: {
      default: DataSyncNav,
      a: BasicInformation
    }
  },
  {
    path: "/basic_information_add",
    name: "basic-information-add",
    components: {
      default: DataSyncNav,
      a: BasicInformationAdd
    }
  },
  {
    path: "/basic_information_modify",
    name: "basic-information-modify",
    components: {
      default: DataSyncNav,
      a: BasicInformationModify
    }
  },
  {
    path: "/cost_center",
    name: "cost-center",
    components: {
      default: DataSyncNav,
      a: CostCenter
    }
  },
  {
    path: "/cost_center_add",
    name: "cost-center-add",
    components: {
      default: DataSyncNav,
      a: CostCenterAdd
    }
  },
  {
    path: "/cost_center_modify",
    name: "cost-center-modify",
    components: {
      default: DataSyncNav,
      a: CostCenterModify
    }
  },
  {
    path: "/scenario_template",
    name: "scenario-template",
    components: {
      default: DataSyncNav,
      a: ScenarioTemplate
    }
  },
  {
    path: "/scenario_template_add",
    name: "scenario-template-add",
    components: {
      default: DataSyncNav,
      a: ScenarioTemplateAdd
    }
  },
  {
    path: "/scenario_template_modify",
    name: "scenario-template-modify",
    components: {
      default: DataSyncNav,
      a: ScenarioTemplateModify
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/Group.js